<template>
  <div>
    <SliderWrapper
      class="slider-wrappper"
      :board="board"
    ></SliderWrapper>
    <Logout></Logout>
  </div>
</template>


<script>
import SliderWrapper from './SliderWrapper';
import auth from '@/mixins/auth';
import Logout from '@/views/Logout';

export default {
  name: "Dashboard",
  components: {
    SliderWrapper,
    Logout
  },
  mixins: [auth],
  data() {
    return {
      is_slider: null,
      dashBoard: null,
    }
  },
  computed: {
    board() {
      return this.$store.state.boards.active ? this.$store.state.boards.boards[this.$store.state.boards.active] : null;
    }
  },
}
</script>

<style>
.w-100 {
  width: 100%;
}
.h-100 {
  height: 100%;
}
.vue-grid-layout {
  height: calc(100vh - 74px) !important;
}
.slide {
  height: calc(100vh - 74px);
  width: 100%;
}
.vh-2 {
  height: 25vh;
}
.white {
  color: #000;
  background: transparent;
}

.bkg-transparent {
  background: transparent !important;
}

</style>
